import { authFetch, BASE_BACKEND_URL } from '../../auth'
import React, { useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import Pagination from '../../layout/Pagination'
import SearchInput from '../../layout/SearchInput'
import { canManagePriceLists } from '../../global_context/capabilities/priceCapabilities'
import DropdownActionButton from '../../components/action_button/DropdownActionButton'
import ActionButtonProvider from '../../components/action_button/ActionButtonContext'
import { Table } from 'react-bootstrap'
import LoadingScreen from '../../components/LoadingScreen'
import GuidanceNote from '../../components/GuidanceNote'
import { buildPriceListApiUrl } from './helpers/priceListUrlHelpers'

const createPriceListRouteWithParam = (paramName, value) =>
  `/crear_lista_de_precios?${new URLSearchParams({ [paramName]: value ?? '' }).toString()}`

const PriceListIndexView = (props) => {
  const navigate = useNavigate()

  const showModel = (id) => {
    window.open(`/listas_de_precios/${id}`)
  }

  const redirectToCreatePriceList = () => {
    navigate('/crear_lista_de_precios')
  }

  const handleDisablePriceList = (model) => {
    const response = window.confirm('¿Está seguro de que desea suspender esta lista de precio?')

    if (!response) return

    authFetch(buildPriceListApiUrl(BASE_BACKEND_URL, 'price_lists', model.db_ref), {
      method: 'DELETE'
    })
      .then((res) => {
        if (res.status === 204) {
          fetchDataFromServer(query, current_page)
        }
      })
      .catch(console.error)
  }

  const handleCopyPriceList = (model) => {
    const response = window.confirm(
      '¿Está seguro de crear una copia a partir de esta lista de precio?'
    )
    if (response === true) {
      navigate(createPriceListRouteWithParam('copy', model.db_ref))
    }
  }

  const handleEditPriceList = (model) => {
    navigate(createPriceListRouteWithParam('edit', model.db_ref))
  }

  const {
    data,
    clientsScopeLimited = false,
    isFetching,
    title,
    query,
    onSearchUpdate,
    total_pages,
    current_page,
    handlePaginationClick,
    fetchDataFromServer
  } = props

  if (isFetching) {
    return <LoadingScreen text="Cargando..." />
  } else {
    return (
      <>
        <div className="index-header detailed-container">
          <h2 className="mb-20">{title}</h2>
          <div className="index-buttons">
            {canManagePriceLists() && (
              <button onClick={redirectToCreatePriceList}>Crear Lista de Precio</button>
            )}
          </div>
        </div>
        <div className="index-table">
          <div className="show-area">
            <div className="title-and-search-containter">
              <h4 className="text-sub-title">Listas de Precios:</h4>
              <div className="search-input-containter mb-20">
                <SearchInput
                  query={query}
                  onSearch={onSearchUpdate}
                  onClearSearch={() => onSearchUpdate('')}
                  placeholder="Buscar Lista por código o nombre"
                />
              </div>
            </div>
            {clientsScopeLimited && (
              <GuidanceNote
                title="Lista compartida"
                message="Esta lista es compartida. Puedes ver todas sus relaciones, pero solo abrir y modificar los clientes y productos que tienes asignados."
                sx={{ mb: 2 }}
              />
            )}
            <Table hover responsive>
              <thead className="table-header-gray">
                <tr>
                  <th className="th-index-state">
                    <span className="th-header-text">ESTADO</span>
                  </th>
                  <th className="th-index-price-list th-width-20">
                    <span className="th-header-text">CÓDIGO</span>
                  </th>
                  <th className="th-index-price-list th-width-55">
                    <span className="th-header-text">NOMBRE DE LISTA DE PRECIO</span>
                  </th>
                  <th className="th-index-price-list">
                    <span className="th-header-text"># CLIENTES ASOCIADOS</span>
                  </th>

                  {canManagePriceLists() && (
                    <th className="th-index-state">
                      <span className="th-header-text">ACCIÓN</span>
                    </th>
                  )}
                </tr>
              </thead>
              <tbody>
                <ActionButtonProvider>
                  {data && data.length > 0 ? (
                    data.map((model, index) => (
                      <tr
                        className="cursor-pointer"
                        key={model.id}
                        onClick={() => showModel(model.id)}
                      >
                        <td className="table-body-cell td-text-limited-space" id={model.id}>
                          {model?.active ? 'Activo' : 'Suspendido'}
                        </td>

                        <td className="td-text-limited" id={model.id}>
                          {model?.db_ref || '-'}
                        </td>

                        <td className="td-text-limited" id={model.id}>
                          {model?.description || '-'}
                        </td>

                        <td className="td-text-limited" id={model.id}>
                          {model?.clients_count ?? '-'}
                        </td>

                        {canManagePriceLists() && (
                          <td>
                            <div
                              className={`action-wrapper ${!model.active ? 'disabled' : ''}`}
                              title={!model.active ? 'Lista suspendida' : ''}
                            >
                              <DropdownActionButton
                                id={`btn-dropdown-${model?.db_ref}`}
                                list={[
                                  {
                                    disabled: !model.active,
                                    text: 'Editar',
                                    handler: () => handleEditPriceList(model)
                                  },
                                  {
                                    disabled: !model.active,
                                    text: 'Crear copia',
                                    handler: () => handleCopyPriceList(model)
                                  },
                                  {
                                    disabled: !model.active,
                                    text: 'Suspender',
                                    handler: () => handleDisablePriceList(model)
                                  }
                                ]}
                              />
                            </div>
                          </td>
                        )}
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="8" className="td-text-limited td-text-limited-space">
                        No hay listas de precio disponibles.
                      </td>
                    </tr>
                  )}
                </ActionButtonProvider>
              </tbody>
            </Table>
          </div>
        </div>
        {total_pages > 1 && (
          <nav className="index-table">
            <Pagination
              current_page={current_page}
              total_pages={total_pages}
              handle_pagination={handlePaginationClick}
            />
          </nav>
        )}
      </>
    )
  }
}

export default PriceListIndexView
